import React from "react";

import { RightMenuOnMyText } from "./onMyText";
import { useAtomValue } from "jotai";
import { userAtom } from "../../store";
import { RightMenuOnOppositionText } from "./onOppositionText";
import { ChatMessageItem } from "../../types";
import { makeSenderFlag } from "../../Utils/common";

interface RightMenuProps {
    msg: ChatMessageItem; //选中的消息
    handleRetract: () => void;
    handleDelete: () => void;
}

export default function RightMenu({
    msg,
    handleRetract,
    handleDelete
}: RightMenuProps) {
    const { senderFlag } = useAtomValue(userAtom);

    if (makeSenderFlag(msg.sender) === senderFlag) {
        return (
            <RightMenuOnMyText
                msg={msg}
                handleRetract={handleRetract}
                handleDelete={handleDelete}
            />
        );
    }

    return <RightMenuOnOppositionText msg={msg} />;
}
